import React from "react";
import {Spinner} from 'reactstrap';
import {InputPassword} from "components/common/InputPassword";
import {ConfigItem} from "components/user/configuration/ConfigItem";
import {images} from "assets/img/user/configuration.js";
import {app} from "app/app";

export class PasswordConfiguration extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: app.currentUser()
        }
    }

    renderFormErrors() {
        if (this.props.passwordsNotEqualError) {
            return <div className="form-error">Las contraseñas no son iguales</div>;
        } else if (this.props.hasValidationErrors) {
            return <div className="form-error">{this.props.validationErrorMessage}</div>;
        }
    }

    renderSubmitButton() {
        if (this.props.loading) {
            return <Spinner className="spinner-color"/>;
        } else {
            return <button className="cta-button" onClick={this.props.handleSubmit}>CAMBIAR CONTRASEÑA</button>;
        }
    }

    render() {
        return (
            <ConfigItem
                title="Contraseña"
                subtitle="***********"
                icon={images.pass}>
                <div className="config-pass">
                    <p>Por seguridad, vamos a necesitar que ingreses tu actual contraseña antes de ingresar la
                        nueva.</p>
                    <InputPassword placeholder="Ingresá tu contraseña" onChange={this.props.handleChange}
                                   name="password" withValidation={false}/>
                    <InputPassword placeholder="Ingresá tu nueva constraseña"
                                   onChange={this.props.handleChange}
                                   onValidationChange={this.props.handleValidationChange}
                                   name="password1" withValidation={true}/>
                    <InputPassword placeholder="Repite tu nueva contraseña" onChange={this.props.handleChange}
                                   name="password2" withValidation={false}/>
                    {this.renderFormErrors()}
                    <div style={{"display": "flex", "justifyContent": "center"}}>
                        {this.renderSubmitButton()}
                    </div>
                </div>
            </ConfigItem>
        )
    }
}
